import { ChangeEvent, useCallback, useEffect, useMemo, useState } from "react";
import { getItemPopupList } from "src/apis/itemApi";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { ItemDto } from "src/dtos/item/itemDto";
import useUiuxStore from "src/store/useUiuxStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useKSK1081_R01Store, { defaultKSK1081_R01Filter } from "./Store_KSK1081_R01";
import { WareHouseDto } from "src/dtos/warehouse/wareHouseDto";
import { SubtotalControl } from "./components/SubtotalControl";
import { searchFieldWidth, searchLabelStyle, SearchSpacer } from "src/components/common/common";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

interface Props {}

export const SearchSection_KSK1081_R01 = ({}: Props) => {
    const {
        KSK1081_R01Filter, 
        setKSK1081_R01Filter
    } = useKSK1081_R01Store();

    const {
        wmsCdList,    // ✅ 물류센터 공통코드
        warehouseCdList,      // ✅ 창고 공통코드
        itemGroupList,        // ✅ 품목그룹 공통코드
        brandCdList         // ✅ 브랜드 공통코드
    } = useCommonCodeStore();

    const { setCodeSearchModalProps } = useUiuxStore();

	const itemCdHandleFoucsId = 'itemCd_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'itemCd',
			category: '품목코드',
			focusId: itemCdHandleFoucsId,
			responseMapping: {
				itemCd: 'itemCd',
				itemNm: 'itemNm',
			},
			extraFilter: () => ({
				itemCd: KSK1081_R01Filter.itemCd || '',
				itemNm: KSK1081_R01Filter.itemNm || '',
			}),
		},
	];
	
	const { getFieldHandlers } = useInfoFormEvents({
		editData: KSK1081_R01Filter,
		setEditData: setKSK1081_R01Filter,
		defaultData: defaultKSK1081_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK1081_R01_search'
	});

	const dropDownWrapperOption = {
		wrapperStyle: 'w-[250px] min-w-[250px]',
		titleStyle: searchLabelStyle,
		selectStyle: 'w-[120px] min-w-[120px]', 
	}

	const codeModalWrapperOption = {
		wrapperStyle: "w-[600px] min-w-[600px] mr-[10px]",
		titleStyle: "w-[80px] min-w-[80px] text-left",
		codeInputStyle: "w-[190px] min-w-[190px]",
		nameTagStyle: "w-[300px] min-w-[300px] text-left",
	};

    return (
        <div className="w-full">
            <SearchSectionDoubleForm buttonText="조회" >
                {/* 물류센터 선택 */}
                <SearchDropDownForm<SysCodeDto>
                    label="물류센터"
                    value={KSK1081_R01Filter.logicCenter}
                    optionList={wmsCdList}
                    onChangeValue={(v) =>
                        setKSK1081_R01Filter({ logicCenter: v === "all" ? "" : v, })
                    }
					wrapperOption={dropDownWrapperOption}
                />

                {/* 창고 선택 */}
                <SearchDropDownForm<WareHouseDto>
                    label="창고명"
                    value={KSK1081_R01Filter.warehouseCd}
                    optionList={warehouseCdList}
                    onChangeValue={(v) =>
                        setKSK1081_R01Filter({ warehouseCd: v === "all" ? "" : v, })
                    }
					wrapperOption={dropDownWrapperOption}
                    />

                {/* 브랜드 선택 */}
                <SearchDropDownForm<SysCodeDto>
                    label="브랜드"
                    value={KSK1081_R01Filter.brandCd}
                    optionList={brandCdList}
                    onChangeValue={(v) =>
                        setKSK1081_R01Filter({ brandCd: v === "all" ? "" : v, })
                    }
					wrapperOption={dropDownWrapperOption}
                />

                {/* 품목 검색 */}
                <SearchCodeModalForm
                    label="품목코드"
                    value={KSK1081_R01Filter.itemCd}
                    valueLabel={KSK1081_R01Filter.itemNm || ""}
					handleFoucsId={itemCdHandleFoucsId}
                    onChange={getFieldHandlers('itemCd').onChange}
                    onDoubleClick={getFieldHandlers('itemCd').onDoubleClick}
                    onKeyDown={getFieldHandlers('itemCd').onEnterKeyDown}
					wrapperOption={codeModalWrapperOption}
                />

                {/* 품목그룹 선택 */}
                <SearchDropDownForm<SysCodeDto>
                    label="품목그룹"
                    value={KSK1081_R01Filter.itemGroup}
                    optionList={itemGroupList}
                    onChangeValue={(v) =>
                        setKSK1081_R01Filter({ itemGroup: v === "all" ? "" : v, })
                    }
					wrapperOption={dropDownWrapperOption}
                />
                <SearchSpacer/>

                {/* 소계 컨트롤 */}
                <SubtotalControl />
            </SearchSectionDoubleForm>
        </div>
    );
};
